import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import MainTitle from 'base/components/MainTitle';
import SubmitButton from 'base/components/forms/SubmitButton';
import { FormikSelectField } from 'base/components/forms/formik';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import ModalHeader from 'modal/components/ModalHeader';
import FormikDropzoneField from 'base/components/forms/formik/FormikDropzoneField';
import SpinnerOverlay from 'base/components/SpinnerOverlay';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import { getActiveSpaceFolderSelectOptions } from '../../store/folders/selectors';
import { fetchAllTags } from '../../store/tags/actions';
import { getAllTags } from '../../store/tags/selectors';
import {
  getActiveDocument,
  getIsUpdateInProgress,
  getIsUpdatePasswordMismatch,
} from '../../store/documents/selectors';
import { updateDocument } from '../../store/documents/actions';

class DocumentEditModal extends React.Component {
  componentDidMount() {
    this.props.fetchTags();
  }

  render() {
    const {
      document,
      updateDocument,
      tags,
      folderSelectOptions,
      isUpdateInProgress,
      isUpdatePasswordMismatch,
    } = this.props;
    const tagOptions = tags.map((tag) => ({ value: tag.id, label: tag.name }));

    return (
      <>
        <ModalHeader>
          <MainTitle>Edit Document</MainTitle>
        </ModalHeader>

        <Formik
          initialValues={{
            name: document.name,
            tags: document.tags || [],
            folder: document.folder || null,
            newFile: null,
            password: null,
          }}
          validationSchema={
                  Yup.object().shape({
                    name: Yup.string()
                      .required('Name is required.'),
                  })
                }
                render={({ errors, isSubmitting }) => ( // eslint-disable-line
                  <Form>
                    {isUpdateInProgress && (
                      <SpinnerOverlay />
                    )}
                    {isUpdatePasswordMismatch && (
                      <>
                        <FieldWrapper>
                          <strong>Password required to replace document</strong>
                          <br />
                          <small>The document is password protected and contains annotations</small>
                        </FieldWrapper>
                        <Field
                          type="password"
                          name="password"
                          label="PDF password"
                          component={FormikInputField}
                        />
                      </>
                    )}
                    <Field
                      type="text"
                      name="name"
                      label="Name"
                      placeholder="Name"
                      component={FormikInputField}
                      hidden={isUpdateInProgress || isUpdatePasswordMismatch}
                    />
                    <Field
                      type="select"
                      name="tags"
                      component={FormikSelectField}
                      placeholder="Tags"
                      label="Tags"
                      isMulti
                      options={tagOptions}
                      hidden={isUpdateInProgress || isUpdatePasswordMismatch}
                    />
                    <Field
                      type="select"
                      name="folder"
                      component={FormikSelectField}
                      label="Folder"
                      options={folderSelectOptions}
                      hidden={isUpdateInProgress || isUpdatePasswordMismatch}
                    />
                    <Field
                      type="text"
                      name="newFile"
                      label="Replace file with new version"
                      multiple={false}
                      component={FormikDropzoneField}
                      hidden={isUpdateInProgress || isUpdatePasswordMismatch}
                    />

                    <SubmitButton type="submit">
                        Update Document
                    </SubmitButton>
                  </Form>
                )}
          onSubmit={(values) => {
            const updatedDocument = {
              ...document,
              name: values.name,
              tags: values.tags || undefined,
              folder: values.folder,
            };
            updateDocument(updatedDocument, values.newFile, values.password);
          }}
        />
      </>
    );
  }
}
DocumentEditModal.propTypes = {
  document: PropTypes.objectOf(PropTypes.any).isRequired,
  tags: PropTypes.arrayOf(PropTypes.any).isRequired,
  updateDocument: PropTypes.func.isRequired,
  fetchTags: PropTypes.func.isRequired, // eslint-disable-line
  folderSelectOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  isUpdatePasswordMismatch: PropTypes.bool.isRequired,
  isUpdateInProgress: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  document: getActiveDocument(state),
  tags: getAllTags(state),
  folderSelectOptions: getActiveSpaceFolderSelectOptions(state),
  isUpdatePasswordMismatch: getIsUpdatePasswordMismatch(state),
  isUpdateInProgress: getIsUpdateInProgress(state),
});

const mapDispatchToProps = {
  updateDocument,
  fetchTags: fetchAllTags,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentEditModal);
